export default "__VITE_PUBLIC_ASSET__a95f9460__"